import { Stack, Box, Center, Avatar, Grid, GridItem, IconButton, Text } from '@chakra-ui/react'
import React from 'react'
import { BiMessageDetail } from 'react-icons/bi'
import { BsFillMicMuteFill, BsFillMicFill, BsTelephone } from 'react-icons/bs'
import { MdPhonePaused, MdOutlineDialpad } from 'react-icons/md'
import { useCallDurationLabel } from '../contact-center.hooks'
import {  maskPhoneNumber } from '../contact-center.utils'
import { useDialerCallStatus, useDialerState } from './dialer.hooks'

type CallingScreenProps = {
  endCurrentCall: () => void
  muteCurrentCall: () => void
}
export const CallingScreen: React.FC<CallingScreenProps> = ({ endCurrentCall, muteCurrentCall }) => {
  const { dialerState } = useDialerState()
  const { status: callStatus, set: setCallStatus } = useDialerCallStatus()
  const { label: callDurationLabel } = useCallDurationLabel();

  const toggleKeyPad = () => {
    setCallStatus(prev => ({ ...prev, isKeyPadOpen: !callStatus.isKeyPadOpen }))
  }

  return (
    <Stack spacing="15px">
      <Box>
        <Center>
          <Avatar size="xl" />
        </Center>
        <Center mt="5px">
          <Text color="gray.600" fontSize="14px" fontWeight="400">
            ({callStatus.currentLabel})
          </Text>
        </Center>
        <Center mt="5px">
          <Text color="gray.700" fontSize="22px" fontWeight="400">
            {maskPhoneNumber(dialerState.number)}
          </Text>
        </Center>
        <Center mt="5px">
          <Text color="gray.700" fontSize="24px" fontWeight="400">
            {callDurationLabel}
          </Text>
        </Center>
      </Box>
      <Box>
        <Center>
          <Grid templateColumns="repeat(2, 100px)" columnGap="25px" rowGap="0px">
            <GridItem>
              <IconButton
                disabled={true}
                backgroundColor="transparent"
                zIndex="10"
                aria-label="message"
                icon={
                  <Box background="transparent">
                    <BiMessageDetail fontSize="35px" color="#345ea6" />
                  </Box>
                }
                margin="15px"
                height="80px"
                width="50px"
                borderRadius="100px"
                border="1px solid #ddd"
                transform="scale(0.7)"
              />
            </GridItem>
            <GridItem>
              <IconButton
                backgroundColor="transparent"
                zIndex="10"
                aria-label="mute and unmute"
                icon={
                  <Box background="transparent">
                    {callStatus.mute ? (
                      <BsFillMicMuteFill fontSize="35px" color="#345ea6" />
                    ) : (
                      <BsFillMicFill fontSize="35px" color="#345ea6" />
                    )}
                  </Box>
                }
                onClick={muteCurrentCall}
                _hover={{
                  backgroundColor: 'transparent',
                  opacity: 0.8,
                  transform: 'scale(0.8)',
                }}
                _active={{
                  backgroundColor: 'transparent',
                  opacity: 0.8,
                  transform: 'scale(0.8)',
                }}
                margin="15px"
                height="80px"
                width="50px"
                borderRadius="100px"
                transform="scale(0.7)"
                border="1px solid #ddd"
              />
            </GridItem>
            <GridItem>
              <IconButton
                backgroundColor="transparent"
                zIndex="10"
                aria-label="mute and unmute"
                disabled={true}
                icon={
                  <Box background="transparent">
                    <MdPhonePaused fontSize="35px" color="#345ea6" />
                  </Box>
                }
                margin="15px"
                height="80px"
                width="50px"
                transform="scale(0.7)"
                borderRadius="100px"
                border="1px solid #ddd"
              />
            </GridItem>
            <GridItem>
              <IconButton
                backgroundColor="transparent"
                zIndex="10"
                aria-label="keypad"
                icon={
                  <Box background="transparent">
                    <MdOutlineDialpad fontSize="35px" color="#345ea6" />
                  </Box>
                }
                _hover={{ background: 'transparent', transform: 'scale(0.8)' }}
                _active={{ background: 'transparent' }}
                onClick={toggleKeyPad}
                margin="15px"
                height="80px"
                width="50px"
                borderRadius="100px"
                transform="scale(0.7)"
                border="1px solid #ddd"
              />
            </GridItem>
          </Grid>
        </Center>
      </Box>
      <Box>
        <Center>
          <IconButton
            backgroundColor="red"
            zIndex="10"
            aria-label="end-phone-dialer"
            sx={{
              svg: {
                transform: 'rotate(135deg) !important',
              },
            }}
            icon={<BsTelephone fontSize="35px" />}
            onClick={endCurrentCall}
            _hover={{
              backgroundColor: 'red',
              opacity: 0.8,
              transform: 'scale(0.8)',
            }}
            _active={{
              backgroundColor: 'red',
              opacity: 0.8,
              transform: 'scale(0.8)',
            }}
            margin="15px"
            marginTop="0px"
            height="80px"
            width="50ox"
            borderRadius="100px"
            transform="scale(0.7)"
            boxShadow="0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12)"
          />
        </Center>
      </Box>
    </Stack>
  )
}
